import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Injectable({
  providedIn: "root"
})
export class AggregateReportService {
  private baseUrl: string = this.config.protectedResourceEndpoint;

  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private http: HttpClient
  ) {}

  public getTableLength$(uri: string): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}${uri}`);
  }

  public resetTableLength$(uri: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}${uri}`);
  }
}